<template>
  <div 
    class=" ">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, profil Anda
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            :min-height="`calc(100vh - 220px)`"
            class="box-shadow mb-3"
            style="overflow-y: auto;">
            <v-card-text
              class="pt-8">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div
                    class="mb-4">
                    <v-row>
                      <v-col cols="9">
                        <ValidationProvider
                          name="Nama" 
                          rules="required" 
                          v-slot="{ errors, valid }">
                          <div class="body-2 mb-2">
                            <span class="red--text">*</span>
                            Nama
                          </div>

                          <v-text-field
                            v-on:keydown.enter.prevent="save()"
                            outlined
                            rounded
                            dense

                            :color="set_color"
                            placeholder="Contoh. Klinik Kecantikan"

                            hide-details

                            v-model="form.name"
                            :error-messages="errors"
                            required
                            class="mb-6"
                            style="border-radius: 10px;">
                            <template v-slot:append-outer>
                              <div v-if="errors.length > 0">
                                <v-tooltip top color="#ff5252">
                                  <template v-slot:activator="{ on }">
                                    <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                  </template>
                                  
                                  {{ errors[0] }}
                                </v-tooltip>
                              </div>

                              <div v-if="form.name !== '' && valid">
                                <v-icon color="success">mdi-check-circle-outline</v-icon>
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider>

                        <v-row>
                          <v-col cols="6">
                            <ValidationProvider 
                              name="Email" 
                              rules="required|email" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>

                                Email
                              </div>

                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense

                                disabled

                                :color="set_color"
                                placeholder="Contoh. XXXX@gmail.com"

                                hide-details

                                v-model="form.email"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.email !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                          <v-col cols="6">
                            <ValidationProvider 
                              name="Mobilephone" 
                              rules="required|min:10|max:13" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>

                                Mobilephone
                              </div>

                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense

                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                type="number"
                                min="0"

                                :color="set_color"
                                placeholder="Contoh. 081XXXXXXXXX"

                                hide-details

                                v-model="form.mobilephone"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.mobilephone !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="3" class="d-flex justify-center">
                        <v-card flat width="200" height="200">
                          <v-card-title class="pa-0 text-center">
    
                            <v-img
                              :src="form.image_url !== undefined && form.image_url !== '' ? form.image_url : require('@/assets/image/member_default.png')"
                              width="200"
                              height="200"
                              :gradient="process.image ? `to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)` : ''"
                              style="border-radius: 16px; border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                              <v-row
                                class="fill-height ma-0"
                                v-if="process.image"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </v-img>
                            <div class="mt-2">
                              <uploadfolder
                                v-model="upload.image">
                                <div 
                                  slot="activator">
                                  <v-btn
                                    class="text-capitalize white--text"
                                    width="200"
                                    height="40"
                                    outlined
                                    style="border-radius: 8px;"
                                    :disabled="process.image"
                                    color="grey darken-2"
                                    elevation="0"
                                  >
                                    <v-icon dark size="22">
                                      mdi-pencil
                                    </v-icon>
                                    Pilih Foto
                                  </v-btn>
                                </div>
                              </uploadfolder>
                            </div>
                          </v-card-title>
                        </v-card>
                      </v-col>
                    </v-row>
                    

                  </div>
                  
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
          <div class="text-right pt-5">
            <v-btn 
              @click="save()"
              :loading="process.form"
              :disabled="process.form"
              color="#4B4B4B"
              elevation="0"
              class="body-2 white--text text-capitalize ml-3"
              style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
              <v-icon
                size="20">
                mdi-checkbox-marked-circle-outline
              </v-icon>

              <span
                class="ml-2">
                Simpan
              </span>
            </v-btn>
          </div>

        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,

        show: {
          old_password: false,
          new_password: false
        },

        dialog: {
          success: false
        },

        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.image_url = this.upload.image.data.full.file_url
              this.form.image_url = this.upload.image.fileuri

              console.log(this.form.image_url)

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/profile_user/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              let user = this.$store.state.user
              user.name = this.form.name
              user.mobilephone = this.form.mobilephone
              user.image_url = this.form.image_url

              // console.log(user)

              TokenService.saveToken(
                this.$store.state.token,
                JSON.stringify(user),
                JSON.stringify(this.$store.state.menu)
              )

              this.$store.state.user = user

              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_image () {
        this.message.error = ''

        // SAVE TO REST API
        // await post(`admin/profile_user/update`, {
        //   data: this.form
        // })
        // .then((response) => {
        //   let res = response.data

        //   if (res.status === 200) {
        //     let user = {
        //       id: this.form.id,
                
        //       name: this.form.name,
        //       nip: this.form.nip,

        //       email: this.form.email,
        //       mobilephone: this.form.mobilephone,
              
        //       image_url: this.form.image_url,
        //       gender: this.form.gender
        //     }

        //     TokenService.saveToken(
        //       this.$store.state.token,
        //       JSON.stringify(user),
        //       JSON.stringify(this.$store.state.menu)
        //     )

        //     this.$store.state.user = user
        //   } else {
        //     this.message.error = res.message
        //   }
        // })
      }
    }
  }
</script>